import { Link } from "react-router-dom";
import { cases } from "@/mocks/cases";

const HotCases = () => {
  const hot = [...cases].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const [first, ...rest] = hot;

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <p className="text-sm font-medium text-primary-600 mb-2">热度榜</p>
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
              本周热门塌房
            </h2>
          </div>
          <Link
            to="/cases"
            className="inline-flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部案例
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <article className="lg:col-span-7 group bg-background-100 border border-background-200/80 rounded-lg overflow-hidden">
            <Link to={`/cases/${first.slug}`} className="block relative aspect-[16/10] overflow-hidden">
              <img
                src={first.cover}
                alt={`${first.name} 塌房事件封面`}
                title={`${first.name} 塌房事件档案`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute top-4 left-4 px-3 py-1 rounded-md text-xs md:text-sm font-bold bg-primary-500 text-background-50">
                热度 TOP 1
              </span>
            </Link>
            <div className="p-5 md:p-7">
              <div className="flex items-center gap-2 text-xs text-foreground-500 mb-3">
                <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
                  {first.category}
                </span>
                <span>{first.platform}</span>
              </div>
              <h3 className="font-heading font-black text-xl md:text-3xl text-foreground-950">
                <Link to={`/cases/${first.slug}`} className="hover:text-primary-600 transition-colors">
                  {first.name}
                </Link>
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                {first.summary}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-3 text-xs md:text-sm text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-fill text-primary-500" />
                  热度 {first.heat}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-history-line" />
                  时间线 {first.timeline.length} 个节点
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-file-list-3-line" />
                  旧料 {first.quotes.length} 条
                </span>
              </div>
            </div>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-3">
            {rest.map((item, index) => (
              <article
                key={item.id}
                className="group flex-1 flex gap-4 p-3 md:p-4 bg-background-100 border border-background-200/80 rounded-lg transition-colors hover:border-primary-300"
              >
                <Link
                  to={`/cases/${item.slug}`}
                  className="relative w-24 md:w-32 shrink-0 aspect-square rounded-md overflow-hidden"
                >
                  <img
                    src={item.cover}
                    alt={`${item.name} 塌房事件缩略图`}
                    className="w-full h-full object-cover"
                  />
                  <span className="absolute top-2 left-2 w-6 h-6 flex items-center justify-center rounded-md bg-background-50/95 text-foreground-900 text-xs font-bold">
                    {index + 2}
                  </span>
                </Link>
                <div className="min-w-0 flex flex-col justify-center">
                  <h3 className="font-heading font-bold text-base text-foreground-950 truncate">
                    <Link to={`/cases/${item.slug}`} className="hover:text-primary-600 transition-colors">
                      {item.name}
                    </Link>
                  </h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {item.summary}
                  </p>
                  <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
                      {item.category}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500" />
                      {item.heat}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HotCases;